import { useContext } from 'react';

import { ChatContext, ModalContext, RootContext } from 'contexts/contexts';

export const useRootContext = () => useContext(RootContext);
export const useChatContext = () => useContext(ChatContext);
export const useModalContext = () => useContext(ModalContext);
